import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Gifts = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 49 49"
      fill="none"
      {...rest}
    >
      <path
        d="M40.9043 20.886H8.9043V36.886C8.9043 42.886 10.9043 44.886 16.9043 44.886H32.9043C38.9043 44.886 40.9043 42.886 40.9043 36.886V20.886Z"
        stroke="#F57C00"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.9648 14.886V16.886C43.9648 19.086 42.9048 20.886 39.9648 20.886H9.96484C6.90484 20.886 5.96484 19.086 5.96484 16.886V14.886C5.96484 12.686 6.90484 10.886 9.96484 10.886H39.9648C42.9048 10.886 43.9648 12.686 43.9648 14.886Z"
        stroke="#F57C00"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M24.2444 10.8859H13.2044C12.5244 10.1459 12.5444 9.00587 13.2644 8.28587L16.1044 5.44587C16.8444 4.70587 18.0644 4.70587 18.8044 5.44587L24.2444 10.8859Z"
        stroke="#F57C00"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M36.7041 10.8859H25.6641L31.1041 5.44587C31.8441 4.70587 33.0641 4.70587 33.8041 5.44587L36.6441 8.28587C37.3641 9.00587 37.3841 10.1459 36.7041 10.8859Z"
        stroke="#F57C00"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M18.8457 20.886V31.166C18.8457 32.766 20.6057 33.706 21.9457 32.846L23.8257 31.606C24.5057 31.166 25.3657 31.166 26.0257 31.606L27.8057 32.806C29.1257 33.686 30.9057 32.746 30.9057 31.146V20.886H18.8457Z"
        stroke="#F57C00"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Gifts.displayName = 'Gifts';
